"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFeatureState = exports.isFeatureEnabled = void 0;
function isFeatureEnabled(toggles, feature, fallback) {
    var _a, _b;
    if (fallback === void 0) { fallback = false; }
    var featureState = toggles[feature];
    if (!featureState) {
        return fallback;
    }
    return (_b = (_a = featureState.userOverride) === null || _a === void 0 ? void 0 : _a.boolean()) !== null && _b !== void 0 ? _b : featureState.value.boolean();
}
exports.isFeatureEnabled = isFeatureEnabled;
function toFeatureState(rawFeatures) {
    return Object.keys(rawFeatures).reduce(function (features, featureKey) {
        var rawValue = rawFeatures[featureKey];
        features[featureKey] = {
            // TODO The user should be able to specify this, just putting the shape in for now
            canUserOverride: false,
            value: {
                raw: rawValue,
                boolean: function () {
                    if (rawValue === undefined) {
                        throw new Error(featureKey + " is undefined");
                    }
                    if (rawValue === true ||
                        rawValue === 'true' ||
                        rawValue === '1' ||
                        rawValue === 1) {
                        return true;
                    }
                    if (rawValue === false ||
                        rawValue === 'false' ||
                        rawValue === '0' ||
                        rawValue === 0) {
                        return false;
                    }
                    throw new Error(featureKey + " value is not a boolean: " + rawValue);
                },
                string: function () {
                    if (rawValue === undefined) {
                        throw new Error(featureKey + " is undefined");
                    }
                    if (typeof rawValue !== 'string') {
                        throw new Error(featureKey + " value is not a string: " + rawValue);
                    }
                    return rawValue;
                },
            },
        };
        return features;
    }, {});
}
exports.toFeatureState = toFeatureState;
//# sourceMappingURL=index.js.map